module.exports = __webpack_public_path__ + "img/social-media-color-blocks-black.ae0d22d2.png";